module.exports = __webpack_public_path__ + "img/003.ef1ad8c9.png";